export const getAuthor = (story) => {
  if (story && story.author) {
    const { firstname, lastname, pseudo } = story.author
    return pseudo ? pseudo : firstname + ' ' + lastname
  }
  return 'Inconnu'
}

export const cutText = (s, len=260, cutOnWords=false) => {
  if (s && s.length > len) {
    return cutOnWords ? s.slice(0, s.lastIndexOf(' ') || len) + '...' : s.substring(0, len) + '...'
  }
  return s
}